// extracted by mini-css-extract-plugin
export default {"modalBody":"publishJobModal_modalBody__8NPOa"};